//-- Copyright (c) 2021 TMT Insights Group, LLC
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store';

export const selectProfileSlice = (state: RootState) => state.profile || {};
export const selectProfiles = createSelector(selectProfileSlice, (profile) => profile.profiles || {});
export const selectAllProfiles = createSelector(selectProfileSlice, (profile) => profile.allProfiles || []);
export const selectDeletedProfiles = createSelector(selectProfileSlice, (profile) => profile.deletedProfiles || []);
export const selectShowDeletedProfilesInJobsFilter = createSelector(
  selectProfileSlice,
  (profile) => profile.showDeletedProfilesInJobsFilter || false
);
export const selectAllProfileIdNames = createSelector(selectProfileSlice, (profile) => {
  const profiles = profile.allProfiles || [];
  const map: Record<number, string> = {};

  profiles.forEach((profile) => {
    map[profile.id] = profile.name;
  });

  return map;
});
export const selectAllProfilesByCustomer = createSelector(
  [selectAllProfiles, selectDeletedProfiles, selectShowDeletedProfilesInJobsFilter],
  (allProfiles, deletedProfiles, showDeleted) => {
    const profiles = showDeleted ? [...allProfiles.concat(deletedProfiles)] : [...allProfiles];
    profiles.sort((a, b) => (a.name && b.name ? a.name.localeCompare(b.name) : 0));
    profiles.sort((a, b) => (a.customer_name && b.customer_name ? a.customer_name.localeCompare(b.customer_name) : 0));
    return Object.groupBy(profiles, ({ customer_name }) => customer_name);
  }
);
export const selectProfileById = createSelector(
  selectAllProfiles,
  (_: RootState, profileId: number) => profileId,
  (profiles, profileId) => profiles.find((profile) => profile.id === profileId)
);

export const selectWorkflows = createSelector(selectProfileSlice, (profile) => profile.workflows || {});

export const selectTitleSchema = createSelector(
  selectWorkflows,
  (_, workflow) => workflow,
  (workflows, workflow) => workflows?.[workflow]?.title_schema || {}
);
